<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g transform="translate(-168 -141)"><circle cx="16" cy="16" r="16" style="fill:#fff" transform="translate(168 141)"/><g style="opacity:.999"><path d="M0 0h16v16H0z" style="fill:none" transform="translate(176 149)" fill="currentColor"/><path d="M7.509.288a.479.479 0 0 1 .643 0l6.511 5.836a.5.5 0 0 1-.322.876H1.319A.5.5 0 0 1 1 6.124z" style="fill:#323232" transform="translate(176.17 149.836)" fill="currentColor"/><path d="M3.886 9H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h9.66a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7.773V4.045a.6.6 0 0 0-.6-.6H4.487a.6.6 0 0 0-.6.6V9z" style="fill:#323232" transform="translate(178.17 154.999)" fill="currentColor"/></g></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-home',
});
</script>
